
import $ from 'jquery';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { GroupUserExternal } from '../../backend/backendapi';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { isNoMail, vSelectInModalWithPopper } from '../../../util';
import ExternalUserImageEditor from './ExternalUserEditModal/ExternalUserImageEditor.vue';

@Component({
  components: {
    ExternalUserImageEditor,
    vSelect,
  },
})
export default class ExternalUsersEditor extends Vue {
  @Prop({ required: true })
  readonly availableSalutations!: string[];
  @Prop({ default: false })
  readonly hideDisabled!: boolean;
  @Prop({ default: false })
  readonly allowNoEmailForExternalUsers!: boolean;

  user: GroupUserExternal | null = null;
  noEmail = false;

  vSelectInModalWithPopper = vSelectInModalWithPopper;

  get uid(): string {
    return (this as any)._uid;
  }

  public open(user: GroupUserExternal): void {
    this.user = GroupUserExternal.fromJS(user); //create copy for editing
    this.noEmail = this.allowNoEmailForExternalUsers && isNoMail(this.user.email);
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    this.user = null;
    this.noEmail = false;
    $(this.$refs.modal!).modal('hide');
  }

  @Watch('noEmail', { immediate: true })
  @Watch('user', { deep: true, immediate: true })
  onEmailChanged() {
    if (!this.noEmail || !this.user) {
      return;
    }
    this.user.email = [this.user.firstName, this.user.lastName, this.user.company]
            .filter(e => e?.trim())
            .map(s => s!
                .replaceAll('.', '_')
                .replace(/[^a-zA-Z0-9.+_-]/g, '_'), //replace invalid characters with _
            )
            .join('.')
            .toLocaleLowerCase()
        + '@nomail.com';
  }
}
